<template>
  <div class="layout layout-with-header">
    <!-- header -->
    <pai-header />
    <div class="main-conn">
      <router-view></router-view>
    </div>
    <!--<custom-footer />-->
    <!-- footer -->
    <common-footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer/Footer";

export default {
  components: {
    "common-footer": Footer
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/layout.scss";
</style>
